import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './emailFormStandalone.html?raw';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import "../../moreCore/UI/Container/ExpandableSectionTypes";
import "./emailForm";
import emailForm from './emailForm';
import RequestManager from 'more/RequestManager';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import { EmailEditorTypes } from "./emailTypes";

class emailFormStandalone extends compose(_TabEnabledMixin) {
    /*
        WICHTIG:
        bei verstecken oder zeigen des widgets on_Hide() & on_Show aufrufen um den sceditor neu laden
    */

    templateString: any = template;

    displayField: HTMLDivElement;

    mailForm: MdsLax<InstanceType<typeof emailForm>>;

    reqMgr: RequestManager;

    initialRecipients: Array<EmailEditorTypes.mailRecipient>;

    flagStartupReciverMailWasSet: boolean = false;

    private formWasInitialized = false;

    currentContext: EmailEditorTypes.mailFormContext = {
        isHistoryContext: true
    };

    //#region constructor


    constructor(reciverMail?:string){
        super(...(arguments as unknown as []));
        let inputID = null;
        if (typeof reciverMail == 'string') {
            inputID = reciverMail;
        }
        if ((inputID == null) || (typeof inputID == 'undefined')) {
            this.initialRecipients = null;
        } else {
            this.initialRecipients = inputID;
        }
    }

    //#region initDependencys
    private async initDependencys(){
        //setzt abhaenigkeiten in den header
        const dependency: Record<string, string[]> = {
            css: [
                window.appRoot + "Content/sceditor/base-theme_default.min.css", //sce dependency
                window.appRoot + "Typescript/WidgetCollection/EMail/email.css"
            ],
            js: [
                window.appRoot + "Content/sceditor/sceditor.js", //sce dependency
                window.appRoot + "Content/sceditor/lang/de.js", //sce dependency
                window.appRoot + "Content/sceditor/lang/it.js" //sce dependency
            ]
        };
        for (let key in dependency) {
            for (let targetLink of dependency[key]) {
                let qsTarget = ""; //query select um zu testen, ob die elemente bereits zum head hinzugefuegt worden sind
                switch (key){
                    case "css":
                        qsTarget = "head > link[rel = \"stylesheet\"][href = \"" + targetLink + "\"]"; //css
                        break;
                    case "js":
                        qsTarget = "head > script[src = \"" + targetLink + "\"]"; //js
                        break;
                }
                if ((document.querySelectorAll(qsTarget).length > 0) == false) {
                    //wurde noch nicht geladen
                    let res = await this.initLoadDependency(key, targetLink);
                    if (res != true){
                        console.error("error loading sce editor");
                    }
                }
            }
        }
    }

    private async initLoadDependency(type:string, targetLink:string){
        //ladded alle scripts fuer den sceditor, siehe initDependencys()
        switch (type) {
            case "css":
                return new Promise((resolve, reject) => {
                    let newCssElem = document.createElement("link");
                    newCssElem.setAttribute("rel", "stylesheet");
                    newCssElem.href = targetLink;
                    newCssElem.onload = () => resolve(true);
                    newCssElem.onerror = () => reject(false);
                    document.head.appendChild(newCssElem);
                });
                break;
            case "js":
                return new Promise((resolve, reject) => {
                    let newCssElem = document.createElement("script");
                    newCssElem.setAttribute("rel", "stylesheet");
                    newCssElem.src = targetLink;
                    newCssElem.onload = () => resolve(true);
                    newCssElem.onerror = (e) => reject(e);
                    document.head.appendChild(newCssElem);
                });
                break;
        }
    }

    postCreate() {
    }

    public initLoadFormWithoutID() {
        this.formWasInitialized = true;
        this.loadFormByID();
    }

    private formIsLoaded() {
        if ((this.mailForm === null) || (typeof this.mailForm === 'undefined')) {
            return false;
        }
        return true;
    }

    //#region loadFormByID
    public async loadFormByID(id?: string) {
        await this.initDependencys();
        if (this.formIsLoaded() === true) {
            try {
                this.displayField.innerHTML = "";
            } catch {
                console.warn("unable to destroy form in dom");
            }
        }
        let newID = id;
        if (this.flagStartupReciverMailWasSet === true) {
            newID = "-1";
        }
        this.mailForm = new emailForm();
        this.mailForm.setup(id, this.currentContext);
        this.mailForm.on("permissionError", lang.hitch(this, (ev:Event)=>{
            //wird getriggered wenn die Rolle fehlt
            console.error("missing permission");
            this.destroyRecursive();
            return;
        }));
        this.mailForm.on("emailLoaded", () => { this.emit("emailLoaded") });

        //this.currentForm.on("dirty", lang.hitch(this, this._onDirty));
        this.mailForm.on("saved", lang.hitch(this, (ev) => {
            //#egion after new mail save
            let newID = ev as string;
            this.loadFormByID(newID); //zerstoert die aktuelle "neue" form und laded sie neu vom server, wie in emailHome
            //da die form zerstoert wird, wird das popup vom speichern ansonsten nicht angezeigt :(
            this.mailForm.displayPopupMsg(window.translations["email_mailForm_saveButton_onSuc"]);
            this.fileAttachmentsStorage = []; //file attachments wurden warscheinlich gespeichert, desahlb leeren wir die queue
        }));
        this.mailForm.on("saveForm", lang.hitch(this, () => { this.emit("saveForm");}));
        this.mailForm.placeAt(this.displayField);
        this.mailForm.reloadEditor(); //weil wir ansonsten manchmal 2 sceditoren haben....
        if ((newID !== "-1") && (this.flagStartupReciverMailWasSet == false)) {
            this.mailForm.addRecipients("to", this.initialRecipients);
        }
        //this.mailForm.mailFormEditor.editor_hide_fullscreen_button();
        //this.mailForm.emailReciver.disableSearchButton = true;
        this.flagStartupReciverMailWasSet = true;
        //setzt file attachments
        if (this.fileAttachmentsStorage.length > 0){
            for (let attach of this.fileAttachmentsStorage){
                this.mailForm.addAttachment(attach.filename, attach.fileID, attach.filetype);
            }
        }
        //setzt queued prefill (subject/body/recipients) — siehe prefill()
        if (this.pendingPrefill){
            this._applyPrefill(this.pendingPrefill);
            this.pendingPrefill = null;
        }
    }

    public reloadEditor() {
        if (typeof this.mailForm != 'undefined') {
            if (this.mailForm != null) {
                this.mailForm.reloadEditor();
                return true;
            }
        }
        return false;
    }

    fileAttachmentsStorage: Array<{ filename: string, fileID: string, filetype: 'file_email_attachment' | 'vt_file' | 'fileUploaderGUID' }> = [];
    public addAttachment(filename: string, fileID: string, filetype: 'file_email_attachment' | 'vt_file' | 'fileUploaderGUID') {
        if (typeof this.mailForm != 'undefined'){
            if (this.mailForm != null){
                this.mailForm.addAttachment(filename, fileID, filetype);
                return;
            }
        }
        this.fileAttachmentsStorage.push({filename:filename, fileID:fileID, filetype:filetype});
    }

    // Pre-fill values queued before the form widget exists. Flushed inside loadFormByID()
    // after reloadEditor() (same point as initialRecipients / fileAttachmentsStorage), so the
    // body survives the sceditor boot. Mirrors the fileAttachmentsStorage queue pattern.
    private pendingPrefill: { subject?: string; body?: string; to?: Array<string>; cc?: Array<string>; bcc?: Array<string> } = null;

    public prefill(opts: { subject?: string; body?: string; to?: Array<string>; cc?: Array<string>; bcc?: Array<string> }) {
        if (this.mailForm) {
            this._applyPrefill(opts);
            return;
        }
        this.pendingPrefill = opts;
    }

    // Plain email strings → mailRecipient objects with a null entityID. This is the same
    // shape a manually-typed unknown address produces (emailInput leaves entityID null), so
    // it serializes through addressesStore.getDiffData() exactly like a typed recipient.
    private _toRecipients(mails: Array<string>): Array<EmailEditorTypes.mailRecipient> {
        return mails.map(m => ({ mailaddress: m, entityID: null }));
    }

    private _applyPrefill(opts: { subject?: string; body?: string; to?: Array<string>; cc?: Array<string>; bcc?: Array<string> }) {
        if (!opts || !this.mailForm) return;
        if (opts.subject) this.mailForm.setSubject(opts.subject);
        if (opts.body) this.mailForm.addContent(opts.body); // blank mail starts empty → append == set
        if (opts.to && opts.to.length) this.mailForm.addRecipients("to", this._toRecipients(opts.to));
        if (opts.cc && opts.cc.length) this.mailForm.addRecipients("cc", this._toRecipients(opts.cc));
        if (opts.bcc && opts.bcc.length) this.mailForm.addRecipients("bcc", this._toRecipients(opts.bcc));
    }

    public setMailFormContext(ct: EmailEditorTypes.mailFormContext){
        this.currentContext = ct;
        if (typeof this.mailForm != 'undefined') {
            this.mailForm.setMailFormContext(ct);
        }
    }

    myDlg:MdsLax<InstanceType<typeof GenericDialog>>;
    dlgIsOpen = false;
    dlgWasInit = false;
    public openAsDlg(){
        if (this.formWasInitialized == false){
            this.initLoadFormWithoutID(); //wenn die form nicht geladen worden ist, machen wir es hier
        }
        if (this.dlgWasInit == false){
            this.myDlg.destroy();
            this.myDlg = new GenericDialog();
            this.myDlg.closeOnEnter = false;
            this.myDlg.closeOnEscape = false;
            this.myDlg.destroyOnClose = false;
        }
        this.dlgIsOpen = true;
        if (!this.dlgWasInit){
            this.myDlg.show(
                this,
                window.translations["email_mailFormStandalone_CreateNew"],
                "",
                "",
                "close",
                lang.hitch(this, this._onClose_Dlg),
                { size: "larger", }
            );
            this.dlgWasInit = true;
        }else{
            this.myDlg.show();
        }
        this.emit("dlgOpened");
        return this.myDlg;
    }

    private _onClose_Dlg(){
        this.dlgIsOpen = false;
        this.emit("dlgClosed");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    _onCloseRequest() {
        if (this.formIsLoaded) {
            try {
                return this.mailForm._onCloseRequest();
            } catch {
                return true;
            }
        }
        return true;
    }

    _onShow(){
        this._onActivated();
    }
    _onActivated() {
        if (this.formIsLoaded()) {
            try {
                this.mailForm._onActivated();
            } catch { }
        }
    }
    _onHide() {
        if (this.formIsLoaded()) {
            try {
                this.mailForm._onHide();
            } catch { }
        }
    }

    public addNewMailBtnToDlg(dlg: MdsLax<InstanceType<typeof GenericDialog>>, overwritePosition?: "first" | "last" | "left first" | "left last" | "top" | "top first" | "top last" | number,){
        let pos:any = 'left last';
        if (typeof overwritePosition != 'undefined'){
            pos = overwritePosition;
        }
        //zum einheitlichen hinzufuegen von btn auf einem entity dlg
        dlg.addButton(
            "newMailBtn",
            this.translations["email_mailFormStandalone_CreateNew"],
            lang.hitch(this, this.openNewForm),
            null,
            null,
            "fas fa-envelope-open-text",
            null,
            pos as any,
            true,
        );
        return dlg;
    }

    public addNewMailBtnToTabbingBar(tabbedWidget:any){
        tabbedWidget.requestContextButton({
            label: this.translations["email_mailFormStandalone_CreateNew"],
            heading: this.translations["email_mailFormStandalone_CreateNew"],
            name: this.translations["email_mailFormStandalone_CreateNew"],
            placement: 'actionbar',
            iconClass: "fas fa-envelope-open-text",
            enabled: true,
            callback: lang.hitch(this, this.openNewForm),
            permanent: false,
        });
    }

    public adjustFormForBcc(emailOriginLists: Array<string>, validMailAddresses: Array<string>) {

        this.mailForm.leaveOnlyValidBccAddresses(emailOriginLists, validMailAddresses);
    }

    private async openNewForm(){
        await this.initDependencys();
        //this.loadFormByID();
        this.openAsDlg();
    }
}

mdsLazyProto(emailFormStandalone.prototype, {
  reqMgr: () => (new RequestManager()),
  myDlg: () => (new GenericDialog()),
});
export default mdsWidget(emailFormStandalone);
